import { KeyValue } from "../models/KeyValue";

export const ABSENCE_REASONS: KeyValue[] = [
	{
		key: "CHILD_CARE",
		value: "VAB",
	},
	{
		key: "LEAVE_OF_ABSENCE",
		value: "Tjänsteledig",
	},
	{
		key: "SICK_LEAVE",
		value: "Sjukfrånvaro",
	},
];
